<template>
  <td class="cell">
    <StatementAvatar :icon-name="iconName" :type="type" :size="size" />
  </td>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { EDirection } from '@/modules/transaction/services/unified-account/enums';
import { StatementAvatar } from '@/modules/transaction/components/StatementAvatar';

@Component({
  components: { StatementAvatar }
})
export default class StatementAvatarCell extends Vue {
  @Prop({ type: String, required: true })
  public iconName!: string;

  @Prop({ type: String, required: true })
  private type!: EDirection;

  @Prop({ type: String, default: 'extra-small' })
  readonly size!: string;
}
</script>

<style lang="less" scoped>
.cell {
  padding: @size-spacing-x300 @size-spacing-x300;
  &:first-child {
    border-top-left-radius: @size-radius-x200;
    border-bottom-left-radius: @size-radius-x200;
  }
  &:last-child {
    border-top-right-radius: @size-radius-x200;
    border-bottom-right-radius: @size-radius-x200;
  }
}
</style>
